import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';
import { uiActions } from './ui';
import { history, store } from '../helpers';
import Strings from '../common/Strings';
import { projectActions } from './project';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');

let teamMembersFetched = false;
let teamMembersSnapshot;

function setLoading(loading) {
  return {
    type: ActionTypes.TEAM_MEMBERS_LOADING,
    loading,
  };
}

function setFailed(isFailed) {
  return {
    type: ActionTypes.TEAM_MEMBERS_FAILED,
    isFailed,
  };
}

function teamMemberCreated(teamMember) {
  return {
    type: ActionTypes.TEAM_MEMBER_CREATED,
    teamMember,
  };
}

function teamMemberDeleted(teamMember) {
  return {
    type: ActionTypes.TEAM_MEMBER_DELETED,
    teamMember,
  };
}

function teamMemberUpdated(teamMember) {
  return {
    type: ActionTypes.TEAM_MEMBER_UPDATED,
    teamMember,
  };
}

function setUpdating(isUpdating) {
  return {
    type: ActionTypes.TEAM_MEMBER_UPDATING,
    isUpdating,
  };
}

function stopSync() {
  if (teamMembersSnapshot) {
    teamMembersSnapshot();
  }
}

function fetchTeamMembers() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      teamMembersFetched = false;
      dispatch(setLoading(true));
      dispatch(setFailed(false));
      stopSync();

      teamMembersSnapshot = firebase
        .firestore()
        .collection('teamMembers')
        .where('companyId', '==', currentUser.uid)
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(change => {
              const changeType = change.type;
              const teamMember = change.doc.data();
              teamMember.id = change.doc.id;

              if (changeType === 'added') {
                dispatch(teamMemberCreated(teamMember));
              } else if (changeType === 'modified') {
                dispatch(teamMemberUpdated(teamMember));
              } else if (changeType === 'removed') {
                dispatch(teamMemberDeleted(teamMember));
              }
            });

            if (!teamMembersFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(false));
            }

            teamMembersFetched = true;
          },
          () => {
            if (!teamMembersFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(true));
            }
          },
        );
    }
  };
}

function updateTeamMember(teamMember, hourlyRateChanged) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      // If hourly rate changed update all projects with rate 0
      if (hourlyRateChanged) {
        const projects = Immutable.asMutable(store.getState().projects);

        projects.forEach(project => {
          const teamMembers = Immutable.asMutable(project.teamMembers);
          for (const i in teamMembers) {
            if (
              teamMembers[i].uid === teamMember.uid &&
              teamMembers[i].hourlyRate === 0
            ) {
              teamMembers[i] = Immutable.asMutable(teamMembers[i]);
              teamMembers[i].hourlyRate = teamMember.hourlyRate;
              const p = Immutable.asMutable(project);
              p.teamMembers = teamMembers;
              dispatch(projectActions.updateProject(p));
            }
          }
        });
      }

      dispatch(setUpdating(true));
      const id = teamMember.id;
      firebase
        .firestore()
        .collection('teamMembers')
        .doc(id)
        .set(teamMember, { merge: true })
        .then(() => {
          dispatch(setUpdating(false));
          history.goBack();
        })
        .catch(() => {
          dispatch(setUpdating(false));
          dispatch(
            uiActions.showError(
              Strings.ERROR.defaultTitle,
              Strings.ERROR.defaultBody,
            ),
          );
        });
    }
  };
}

export const teamMemberActions = {
  fetchTeamMembers,
  stopSync,
  updateTeamMember,
};



// WEBPACK FOOTER //
// ./src/actions/teamMember.js